<template>
  <nav @keydown.esc="toggleNav(false)">
    <slot v-bind="{ showNav, toggleNav }"/>
  </nav>
</template>

<script setup>
import { ref } from "vue"

const showNav = ref(false)

const toggleNav = (state) => {
  showNav.value = state

  document.body.classList.toggle("overflow-hidden", state)
}
</script>
